export default __webpack_public_path__ + "static/media/notifications.d64d4575.png";